import { createCss } from '@rybr/styled-modules'

export type ThemeRona = typeof themeRona

export const themeRonaConfig = {
  // From Figma RONA
  'color-background': '#FFF',
  'color-background-brand': '#00315c',
  'color-background-brand-other': '#0e5c71',
  'color-text': '#000',
  'color-text-accent': '#f1ff61',

  'color-primary': '#00315D',
  'color-primary-light': '#004079',
  'color-secondary': '#2437FE',
  'color-accent': '#F2FF61',
  'color-support-1': '#0073B9',
  'color-support-2': '#0066A4',
  'color-support-3': '#B3D5EA',
  'color-support-4': '#E5F1F8',
  'color-support-5': '#003C71',
  'color-support-6': '#00274A',

  'color-new-support-1': '#003e9c',
  'color-new-support-2': '#0047b3',
  'color-new-support-3': '#0065ff',
  'color-new-support-4': '#2b7fff',
  'color-new-support-5': '#6ba6ff',
  'color-new-support-6': '#96c0ff',
  'color-new-support-7': '#e6f0ff',

  'color-neutral-1': '#FFFFFF',
  'color-neutral-2': '#F4F4F4',
  'color-neutral-3': '#D3D3D3',
  'color-neutral-4': '#A8A8A8',
  'color-neutral-5': '#666666',
  'color-neutral-6': '#000000',

  'color-success-dark': '#338700',
  'color-success-light': '#e6f7dc',
  'color-error-dark': '#e82535',
  'color-error-light': '#ffeaeb',
  'color-warning-dark': '#dda42a',
  'color-warning-light': '#fff1d4',
  'color-open-now': '#b9eb9a',
  'color-closed-now': '#feb5bb',

  'color-brand-deal': '#F2FF61',
  'color-badge-eco': '#8DC63F',
  'color-badge-clearance': '#DD1728 ',
  'color-badge-online-exclusive': '#CDD1FF',

  'color-vippro': '#FFEB49',
  'color-divider': '#D6D8DB',

  'color-light-blue': '#F0F6FE',
  'color-text-subtle': '#6B717A'
}

export const themeRona = createCss(themeRonaConfig)
